import axiosInstance from "./api";

const BASE_URL = "/api/metric";

export const metricsService = {
  createMetric: async ({name, value, metadata = [], tags = []}) => {
    const response = await axiosInstance.post(`${BASE_URL}/`, {
      name,
      value,
      metadata,
      tags,
    });
    return response?.data?.data;
  },

  getMetricList: async ({
                          names = [],
                          after = null,
                          before = null,
                          includes_tags = [],
                          excludes_tags = [],
                          latest = false,
                          earliest = false,
                          returnRaw = false,
                        }) => {
    const params = [];
    if (names.length > 0) {
      params.push(`names=${names.join(",")}`);
    }
    if (after) {
      params.push(`after=${after}`);
    }
    if (before) {
      params.push(`before=${before}`);
    }
    if (includes_tags.length > 0) {
      params.push(`includes_tags=${includes_tags.join(",")}`);
    }
    if (excludes_tags.length > 0) {
      params.push(`excludes_tags=${excludes_tags.join(",")}`);
    }
    if (latest) {
      params.push(`latest=true`);
    }
    if (earliest) {
      params.push(`earliest=true`);
    }
    let paramsStr = params.join("&");
    if (paramsStr) {
      paramsStr = `?${paramsStr}`;
    }
    const response = await axiosInstance.get(`${BASE_URL}/${paramsStr}`);
    if (!returnRaw) {
      return response?.data?.data;
    }
    return response?.data;
  },

  getMostRecentActivityByUsername: async () => {
    const response = await axiosInstance.get(
      `${BASE_URL}/most_recent_user_activities/`,
    );
    return response?.data?.data || {};
  },

  getTotalActivityTimeSpentByUsername: async () => {
    const response = await axiosInstance.get(
      `${BASE_URL}/total_user_activities_time_spent/`,
    );
    return response?.data?.data || {};
  },
};